<template>
  <div class="py-4 sm:py-12">
    <div class="p-4 sm:p-12 m-auto bg-white dark:bg-slate-800 outline outline-slate-200 dark:outline-slate-700">
      <main class="max-w-7xl mx-auto prose prose-slate dark:prose-invert">
        <slot />
      </main>
    </div>
  </div>
</template>
